import { PageDocument } from '../../prismicio-types'
import { Section } from './Section'
import { Lang, SHORT_LANG } from '@/const'
import styles from './Page.module.css'
import mainStyles from '../Main.module.css'

type Slice = PageDocument['data']['body'][number]

export class Page {
	static render(props: PageDocument) {
		const {
			uid,
			lang,
			data: { fixed, bg }
		} = props
		const body: Slice[] = props.data.body ?? []

		//screenshots
		if (uid === 'generator' && typeof document !== 'undefined') {
			;(document.querySelector(`.${mainStyles.Container}`) as HTMLElement).style.pointerEvents = 'auto'
		}

		let sectionIndex = -1

		const sections: any[] = []
		body.forEach((slice) => {
			if (slice.slice_type === 'section') {
				sections.push({ ...slice, inner: [] })
			}
		})

		body.forEach((slice) => {
			if (slice.slice_type === 'section') {
				sectionIndex++
			} else if (sectionIndex > -1) {
				if (slice.slice_type === 'stickers') {
					sections[sectionIndex].stickers = slice
				} else {
					sections[sectionIndex].inner.push(slice)
				}
			}
		})

		return /* HTML */ `<main class="${styles.Main}" data-bg="${bg}" data-fixed="${fixed}">
			${sections
				.map((slice) => {
					switch (slice.slice_type) {
						case 'section': {
							return Section.render(slice, fixed, SHORT_LANG[lang as Lang])
						}
					}
				})
				.join('')}
		</main> `
	}
}
